export default "__VITE_ASSET__cNw1h0MS__"